<div
  class="sticky top-0 z-10 flex min-h-[44px] flex-row flex-wrap items-center gap-2 bg-[#fafafa] pb-2"
>
  <h2 class="!m-0 !font-bold">Table</h2>

  <div class="flex grow">
    <mat-icon
      class="icon-sm opacity-50"
      matTooltip="The table shows the detailed data behind your report. You can sort or export this information for deeper analysis."
    >
      info
    </mat-icon>
  </div>

  @if (store.results$ | async; as results) {
    <span class="mat-caption">
      {{ results.filteredCount }} selected out of {{ results.allCount }} records
    </span>

    @if (store.dynamicFilterCount$ | async) {
      <button
        mat-icon-button
        color="primary"
        matTooltip="Reset temporary filters"
        (click)="store.resetActiveFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
    }

    <pt-download-report
      withIcon
      [data]="csvData$ | async"
      [csvTranslator]="csvTranslator$ | async"
    />
  }

  @if ((hasEditPermissions$ | async) && !readonly()) {
    <button mat-stroked-button (click)="store.editColumns()">
      Edit columns
    </button>
  }
</div>

<div class="overflow-hidden rounded-md border border-solid border-slate-200">
  <pr-report-builder-table />
</div>
